import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
export function ProductSection() {
  const [activeTab, setActiveTab] = useState('tomo1');
  const tabs = [{
    id: 'tomo1',
    label: 'TOMO 1',
    emoji: '📕'
  }, {
    id: 'tomo2',
    label: 'TOMO 2',
    emoji: '📗'
  }, {
    id: 'bonos',
    label: 'BONOS 1-5',
    emoji: '🎁'
  }];
  return <section className="py-16 px-4 bg-miel-dark relative" data-id="element-277">
      <div className="max-w-5xl mx-auto" data-id="element-278">
        <FadeIn data-id="element-279">
          <div className="text-center mb-10" data-id="element-280">
            <div className="text-4xl mb-4" data-id="element-281">🏆</div>
            <h2 className="text-miel-crimson font-bold tracking-widest text-sm mb-2" data-id="element-282">
              MIEL ROJA™
            </h2>
            <h3 className="font-playfair text-4xl md:text-5xl text-miel-cream mb-4" data-id="element-283">
              El Protocolo del Retorno —{' '}
              <span className="italic text-miel-gold" data-id="element-284">Completo</span>
            </h3>
            <p className="text-xl text-miel-cream/80" data-id="element-285">
              2 Tomos + 5 Bonos — Del silencio al retorno
            </p>
            <p className="text-miel-goldLight mt-2" data-id="element-286">
              Todo el sistema. Listo para ejecutar hoy.
            </p>
          </div>
        </FadeIn>

        {/* Tabs */}
        <FadeIn delay={0.2} data-id="element-287">
          <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-288">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`
                  px-6 py-3 rounded-t-lg font-semibold text-sm tracking-wider transition-all
                  ${activeTab === tab.id ? 'bg-miel-darker text-miel-gold border-t-2 border-x-2 border-miel-crimson/50 border-b-0' : 'bg-miel-darker/50 text-miel-cream/50 hover:text-miel-cream/80 border border-transparent'}
                `} data-id="element-289">
                {tab.emoji} {tab.label}
              </button>)}
          </div>
        </FadeIn>

        {/* Tab Content */}
        <div className="bg-miel-darker border-2 border-miel-crimson/30 rounded-b-xl rounded-tr-xl p-6 md:p-10 min-h-[500px]" data-id="element-290">
          <AnimatePresence mode="wait" data-id="element-291">
            {activeTab === 'tomo1' && <motion.div key="tomo1" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} data-id="element-292">
                <div className="text-center mb-8 border-b border-miel-crimson/20 pb-8" data-id="element-293">
                  <h4 className="text-2xl md:text-3xl font-playfair text-miel-cream mb-2" data-id="element-294">
                    📕 TOMO 1 — El Grimorio de la Miel Roja
                  </h4>
                  <p className="text-miel-gold italic text-lg mb-4" data-id="element-295">
                    El Manual Profundo (Ebook PDF)
                  </p>
                  <p className="text-miel-cream/80 max-w-3xl mx-auto" data-id="element-296">
                    El sistema completo de rituales de endulzamiento desde cero:
                    la psicología del muro de orgullo, los rituales paso a paso,
                    las pociones de atracción y la conexión onírica. Tu biblia
                    de magia dulce moderna.
                  </p>
                </div>

                <h5 className="text-miel-goldLight font-semibold mb-6" data-id="element-297">
                  Tomo 1 incluye:
                </h5>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-298">
                  {['La Anatomía del Muro: por qué se cerró la comunicación y cómo disolverlo', 'Preparación del Altar de la Bruja Moderna (con ingredientes de tu alacena)', 'Ritual de Limpieza de Hiel: borrá el rencor antes de endulzar', 'La Poción Miel Roja: aceite de atracción magnética paso a paso', 'El Endulzamiento de las 72 Horas: el ritual central del frasco', 'Conexión Onírica: cómo entrar en sus sueños y activar la nostalgia', 'Checklist de diagnóstico energético + Diario de Intención', 'FAQ completo: qué hacer si estás bloqueada, si hay tercera persona, si pasaron días'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-299">
                      <span className="text-green-500 mt-1" data-id="element-300">✅</span>
                      <span className="text-miel-cream/90" data-id="element-301">{item}</span>
                    </div>)}
                </div>
              </motion.div>}

            {activeTab === 'tomo2' && <motion.div key="tomo2" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} data-id="element-302">
                <div className="text-center mb-8 border-b border-miel-crimson/20 pb-8" data-id="element-303">
                  <h4 className="text-2xl md:text-3xl font-playfair text-miel-cream mb-2" data-id="element-304">
                    📗 TOMO 2 — El Protocolo de 72 Horas
                  </h4>
                  <p className="text-miel-gold italic text-lg mb-4" data-id="element-305">
                    La Guía Visual de Acción Rápida (Presentación)
                  </p>
                  <p className="text-miel-cream/80 max-w-3xl mx-auto" data-id="element-306">
                    Para la mujer que necesita actuar YA. Sin leer 60 páginas.
                    Sin improvisar. Un paso a paso visual y directo para
                    ejecutar el endulzamiento desde hoy mismo.
                  </p>
                </div>

                <h5 className="text-miel-goldLight font-semibold mb-6" data-id="element-307">
                  Tomo 2 incluye:
                </h5>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-308">
                  {['La ciencia de la vibración: por qué la frecuencia lo es todo', 'El Código Ético de la Bruja Moderna (sin karma, sin manipulación)', 'DÍA 1: Purificación completa del canal energético', 'DÍA 2: El Núcleo del Endulzamiento (frasco + vela + decreto)', 'DÍA 3: Invasión Psíquica y conexión subconsciente', 'Protocolo de Recepción: qué hacer cuando él escriba', 'El Ritual de Sellado: para que el efecto sea permanente', 'Bitácoras de seguimiento + Calendario Lunar integrado'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-309">
                      <span className="text-green-500 mt-1" data-id="element-310">✅</span>
                      <span className="text-miel-cream/90" data-id="element-311">{item}</span>
                    </div>)}
                </div>
              </motion.div>}

            {activeTab === 'bonos' && <motion.div key="bonos" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} data-id="element-312">
                <div className="text-center mb-8" data-id="element-313">
                  <h4 className="text-2xl md:text-3xl font-playfair text-miel-gold mb-2" data-id="element-314">
                    LOS 5 BONOS ESTRATÉGICOS
                  </h4>
                  <p className="text-miel-cream/80 tracking-widest uppercase text-sm" data-id="element-315">
                    Siempre incluidos con el protocolo
                  </p>
                </div>

                <div className="space-y-6" data-id="element-316">
                  {[{
                num: '01',
                title: '🎁 BONO 1 — Kit de Mensajes "Miel Roja"',
                subtitle: 'Textos que No Espantan y Sí Atraen',
                desc: '30 respuestas listas para cada situación: el "hola" frío, el "te extraño pero…", el "perdón" sin compromiso y la propuesta de verse. Copiás, pegás y respondés con clase.',
                value: '$8.000'
              }, {
                num: '02',
                title: '🎁 BONO 2 — Calendario Lunar Express',
                subtitle: '"Qué Hago Si Hoy Es…" (Guía Anti-Excusas)',
                desc: 'Ajustes exactos para cada fase lunar + plan B de 3 minutos para cuando no tenés tiempo. Cero dudas sobre si "hoy conviene o no".',
                value: '$9.000'
              }, {
                num: '03',
                title: '🎁 BONO 3 — Ritual a Prueba de Errores',
                subtitle: 'Control de Calidad de Bruja Moderna',
                desc: 'Checklist rápida + checklist detallada + sustituciones de ingredientes + 8 errores comunes con corrección inmediata. Para que nunca dudes si lo hiciste bien.',
                value: '$9.000'
              }, {
                num: '04',
                title: '🎁 BONO 4 — Conexión Emocional en 7 Minutos',
                subtitle: 'Ritual de Voz + Mirada',
                desc: 'Rutina diaria de 7 minutos (respiración + script de voz + espejo) para que tu presencia sea tan cálida y firme que él no pueda ignorarte cuando aparezca.',
                value: '$8.000'
              }, {
                num: '05',
                title: '🎁 BONO 5 — Plantillas de Altar "Miel Roja"',
                subtitle: 'Imprimibles + Versiones Secretas',
                desc: '3 manteles de altar premium + 6 sigilos con decretos + 10 tarjetas recortables + versión "modo secreto" para cuando no tenés privacidad. Todo listo para imprimir y montar hoy.',
                value: '$9.000'
              }].map((bono, i) => <div key={i} className="bg-miel-dark p-6 rounded-lg border border-miel-crimson/20 relative overflow-hidden" data-id="element-317">
                      <div className="absolute -right-4 -top-4 text-8xl font-playfair text-miel-crimson/10 font-bold" data-id="element-318">
                        {bono.num}
                      </div>
                      <div className="relative z-10" data-id="element-319">
                        <div className="flex flex-col md:flex-row md:items-center justify-between mb-2 gap-4" data-id="element-320">
                          <h5 className="text-xl font-playfair text-miel-cream font-bold" data-id="element-321">
                            {bono.title}
                          </h5>
                          <div className="bg-miel-darker border border-miel-gold/30 px-3 py-1 rounded text-sm flex items-center gap-2 w-fit" data-id="element-322">
                            <span className="text-miel-cream/50 line-through" data-id="element-323">
                              Valor real {bono.value}
                            </span>
                            <span className="text-green-400 font-bold" data-id="element-324">
                              GRATIS ✅
                            </span>
                          </div>
                        </div>
                        <p className="text-miel-goldLight italic mb-2" data-id="element-325">
                          {bono.subtitle}
                        </p>
                        <p className="text-miel-cream/80 text-sm" data-id="element-326">
                          {bono.desc}
                        </p>
                      </div>
                    </div>)}
                </div>

                <div className="mt-8 p-6 bg-gradient-to-r from-miel-crimson/20 to-miel-darker border border-miel-gold/30 rounded-lg text-center" data-id="element-327">
                  <p className="text-lg text-miel-cream" data-id="element-328">
                    Valor total bonos:{' '}
                    <span className="line-through text-miel-cream/50" data-id="element-329">
                      $43.000
                    </span>
                  </p>
                  <p className="text-2xl font-playfair text-miel-gold mt-2" data-id="element-330">
                    Con El Protocolo del Retorno →{' '}
                    <span className="font-bold" data-id="element-331">GRATIS</span>
                  </p>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}